export default __webpack_public_path__ + "static/media/brainhealth-project-logo-pdf.7afb7ace.png";